import CampaignIcon from '@mui/icons-material/Campaign';
import { useTheme } from '@mui/material';

export const Motivation = () => {
  const theme = useTheme();

  return (
    <CampaignIcon
      fontSize="large"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
